// src/lib/sample-data/invoices.ts
import type { Invoice, InvoiceStatus } from '@/lib/types';
import { format } from 'date-fns';
import { defaultOrganizationId } from './organizations';

const today = new Date();
const issueDate1 = format(today, 'yyyy-MM-dd');
const dueDate1 = format(new Date(today.setDate(today.getDate() + 30)), 'yyyy-MM-dd');

const issueDate2 = format(new Date(today.setDate(today.getDate() - 45)), 'yyyy-MM-dd');
const dueDate2 = format(new Date(today.setDate(today.getDate() + 15)), 'yyyy-MM-dd');

const issueDate3 = format(new Date(today.setDate(today.getDate() - 10)), 'yyyy-MM-dd');
const dueDate3 = format(new Date(today.setDate(today.getDate() + 20)), 'yyyy-MM-dd');

export const sampleInvoicesData: Invoice[] = [
  // Note: Super Admin users should not have sample invoice data in production
  
  // Club Flow: Payment goes directly to club's billing account
  {
    id: '7001234568',
    userUid: '2847391650', // Roger Federer
    invoiceNumber: 'INV-CLUB-2024-001',
    dateGenerated: issueDate2,
    dueDate: dueDate2,
    status: 'Paid' as InvoiceStatus,
    planName: 'Topspin Club Basic Membership',
    amount: 60.00,
    currencyCode: 'CHF',
    clubId: '5847293610', // Topspin Tennis Club (receives payment)
    billingAccountId: 'acct_topspin_tennis_ch', // Club's billing account (like bank account)
    pdfUrl: '/invoices/INV-CLUB-2024-001.pdf',
    organizationId: defaultOrganizationId,
    tenantId: defaultOrganizationId,
  },
  {
    id: '7001234569',
    userUid: '6182947350', // Andy Murray
    invoiceNumber: 'INV-CLUB-2024-002',
    dateGenerated: issueDate3,
    dueDate: dueDate3,
    status: 'Paid' as InvoiceStatus,
    planName: 'Topspin Club Basic Membership',
    amount: 60.00,
    currencyCode: 'CHF',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    pdfUrl: '/invoices/INV-CLUB-2024-002.pdf',
    organizationId: defaultOrganizationId,
    tenantId: defaultOrganizationId,
  },
  {
    id: '7001234570',
    userUid: '3948572610', // Jannik Sinner
    invoiceNumber: 'INV-CLUB-2024-003',
    dateGenerated: issueDate1,
    dueDate: dueDate1,
    status: 'Paid' as InvoiceStatus,
    planName: 'Topspin 10-Hour Booking Pass',
    amount: 180.00,
    currencyCode: 'CHF',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    pdfUrl: '/invoices/INV-CLUB-2024-003.pdf',
    organizationId: defaultOrganizationId,
    tenantId: defaultOrganizationId,
  },
  {
    id: '7001234571',
    userUid: '5729384610', // Coco Gauff
    invoiceNumber: 'INV-CLUB-2024-004',
    dateGenerated: issueDate2,
    dueDate: dueDate2,
    status: 'Paid' as InvoiceStatus,
    planName: 'Alpine Sports Club Membership',
    amount: 75.00,
    currencyCode: 'CHF',
    clubId: '6473820195', // Alpine Sports Center
    billingAccountId: 'acct_alpine_sports_ch', // Club billing ID
    pdfUrl: '/invoices/INV-CLUB-2024-004.pdf',
    organizationId: defaultOrganizationId,
    tenantId: defaultOrganizationId,
  },
  {
    id: '7001234572',
    userUid: '8394751620', // Iga Świątek
    invoiceNumber: 'INV-CLUB-2024-005',
    dateGenerated: issueDate3,
    dueDate: dueDate3,
    status: 'Unpaid' as InvoiceStatus,
    planName: 'Lake Geneva Premium Membership',
    amount: 800.00,
    currencyCode: 'CHF',
    clubId: '7584931206', // Lake Geneva Tennis Club
    billingAccountId: 'acct_lakegeneva_ch', // Club billing ID
    pdfUrl: '/invoices/INV-CLUB-2024-005.pdf',
    organizationId: defaultOrganizationId,
    tenantId: defaultOrganizationId,
  },
  {
    id: '7001234573',
    userUid: '4051728396', // Maria Sharapova (Teacher)
    invoiceNumber: 'INV-CLUB-2024-006',
    dateGenerated: issueDate2,
    dueDate: dueDate2,
    status: 'Paid' as InvoiceStatus,
    planName: 'Topspin Club Basic Membership',
    amount: 60.00,
    currencyCode: 'CHF',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    pdfUrl: '/invoices/INV-CLUB-2024-006.pdf',
    organizationId: defaultOrganizationId,
    tenantId: defaultOrganizationId,
  },
  {
    id: '7001234574',
    userUid: '4051728396', // Maria Sharapova (Teacher)
    invoiceNumber: 'INV-CLUB-2024-007',
    dateGenerated: issueDate1,
    dueDate: dueDate1,
    status: 'Sent' as InvoiceStatus,
    planName: 'Private Tennis Lesson - Teacher Training Course',
    amount: 85.00,
    currencyCode: 'CHF',
    clubId: '5847293610', // Topspin Tennis Club
    billingAccountId: 'acct_topspin_tennis_ch', // Club billing ID
    pdfUrl: '/invoices/INV-CLUB-2024-007.pdf',
    organizationId: defaultOrganizationId,
    tenantId: defaultOrganizationId,
  },
  
  // John McEnroe (Admin) - Global Padel Group
  {
    id: '7001234575',
    userUid: '4567891230', // John McEnroe
    invoiceNumber: 'INV-PADEL-2024-001',
    dateGenerated: issueDate2,
    dueDate: dueDate2,
    status: 'Paid' as InvoiceStatus,
    planName: 'Global Padel Premium Membership',
    amount: 95.00,
    currencyCode: 'CHF',
    clubId: '7384629150', // Global Padel Club
    billingAccountId: 'acct_global_padel_ch',
    pdfUrl: '/invoices/INV-PADEL-2024-001.pdf',
    organizationId: '2951738460',
    tenantId: '2951738460',
  },
  {
    id: '7001234576',
    userUid: '4567891230', // John McEnroe
    invoiceNumber: 'INV-PADEL-2024-002',
    dateGenerated: issueDate1,
    dueDate: dueDate1,
    status: 'Sent' as InvoiceStatus,
    planName: 'Padel Academy Training Package',
    amount: 120.00,
    currencyCode: 'CHF',
    clubId: '7384629150', // Global Padel Club
    billingAccountId: 'acct_global_padel_ch',
    pdfUrl: '/invoices/INV-PADEL-2024-002.pdf',
    organizationId: '2951738460',
    tenantId: '2951738460',
  },
  
  // Venus Williams (Admin) - Urban Tennis Centers
  {
    id: '7001234577',
    userUid: '5678912340', // Venus Williams
    invoiceNumber: 'INV-URBAN-2024-001',
    dateGenerated: issueDate2,
    dueDate: dueDate2,
    status: 'Paid' as InvoiceStatus,
    planName: 'Urban Tennis Elite Membership',
    amount: 150.00,
    currencyCode: 'CHF',
    clubId: '4629385170', // Elite Tennis Academy
    billingAccountId: 'acct_urban_tennis_ch',
    pdfUrl: '/invoices/INV-URBAN-2024-001.pdf',
    organizationId: '6174829350',
    tenantId: '6174829350',
  },
  {
    id: '7001234578',
    userUid: '5678912340', // Venus Williams
    invoiceNumber: 'INV-URBAN-2024-002',
    dateGenerated: issueDate3,
    dueDate: dueDate3,
    status: 'Unpaid' as InvoiceStatus,
    planName: 'Multi-Club Access Pass - Urban Network',
    amount: 200.00,
    currencyCode: 'CHF',
    clubId: '4629385170', // Elite Tennis Academy
    billingAccountId: 'acct_urban_tennis_ch',
    pdfUrl: '/invoices/INV-URBAN-2024-002.pdf',
    organizationId: '6174829350',
    tenantId: '6174829350',
  },
  
  // Amélie Mauresmo (Admin) - Lagardère Paris Racing
  {
    id: '7001234579',
    userUid: '6789123450', // Amélie Mauresmo
    invoiceNumber: 'INV-PARIS-2024-001',
    dateGenerated: issueDate2,
    dueDate: dueDate2,
    status: 'Paid' as InvoiceStatus,
    planName: 'Paris Racing Premium Membership',
    amount: 180.00,
    currencyCode: 'CHF',
    clubId: '1928374650', // Paris Racing
    billingAccountId: 'acct_paris_racing_ch',
    pdfUrl: '/invoices/INV-PARIS-2024-001.pdf',
    organizationId: '9516274830',
    tenantId: '9516274830',
  },
  {
    id: '7001234580',
    userUid: '6789123450', // Amélie Mauresmo
    invoiceNumber: 'INV-PARIS-2024-002',
    dateGenerated: issueDate1,
    dueDate: dueDate1,
    status: 'Pending' as InvoiceStatus,
    planName: 'Multi-Sport Complex Annual Package',
    amount: 350.00,
    currencyCode: 'CHF',
    clubId: '3748591620', // Multi-Sport Complex
    billingAccountId: 'acct_paris_racing_ch',
    pdfUrl: '/invoices/INV-PARIS-2024-002.pdf',
    organizationId: '9516274830',
    tenantId: '9516274830',
  },
  
  // John McEnroe (Admin) - Global Padel Group
  {
    id: '7001234575',
    userUid: '4567891230', // John McEnroe
    invoiceNumber: 'INV-PADEL-2024-001',
    dateGenerated: issueDate2,
    dueDate: dueDate2,
    status: 'Paid' as InvoiceStatus,
    planName: 'Global Padel Premium Membership',
    amount: 95.00,
    currencyCode: 'CHF',
    clubId: '7384629150', // Global Padel Club
    billingAccountId: 'acct_global_padel_ch',
    pdfUrl: '/invoices/INV-PADEL-2024-001.pdf',
    organizationId: '2951738460',
    tenantId: '2951738460',
  },
  {
    id: '7001234576',
    userUid: '4567891230', // John McEnroe
    invoiceNumber: 'INV-PADEL-2024-002',
    dateGenerated: issueDate1,
    dueDate: dueDate1,
    status: 'Sent' as InvoiceStatus,
    planName: 'Padel Academy Training Package',
    amount: 120.00,
    currencyCode: 'CHF',
    clubId: '7384629150', // Global Padel Club
    billingAccountId: 'acct_global_padel_ch',
    pdfUrl: '/invoices/INV-PADEL-2024-002.pdf',
    organizationId: '2951738460',
    tenantId: '2951738460',
  },
  
  // Venus Williams (Admin) - Urban Tennis Centers
  {
    id: '7001234577',
    userUid: '5678912340', // Venus Williams
    invoiceNumber: 'INV-URBAN-2024-001',
    dateGenerated: issueDate2,
    dueDate: dueDate2,
    status: 'Paid' as InvoiceStatus,
    planName: 'Urban Tennis Elite Membership',
    amount: 150.00,
    currencyCode: 'CHF',
    clubId: '4629385170', // Elite Tennis Academy
    billingAccountId: 'acct_urban_tennis_ch',
    pdfUrl: '/invoices/INV-URBAN-2024-001.pdf',
    organizationId: '6174829350',
    tenantId: '6174829350',
  },
  {
    id: '7001234578',
    userUid: '5678912340', // Venus Williams
    invoiceNumber: 'INV-URBAN-2024-002',
    dateGenerated: issueDate3,
    dueDate: dueDate3,
    status: 'Unpaid' as InvoiceStatus,
    planName: 'Multi-Club Access Pass - Urban Network',
    amount: 200.00,
    currencyCode: 'CHF',
    clubId: '4629385170', // Elite Tennis Academy
    billingAccountId: 'acct_urban_tennis_ch',
    pdfUrl: '/invoices/INV-URBAN-2024-002.pdf',
    organizationId: '6174829350',
    tenantId: '6174829350',
  },
  
  // Amélie Mauresmo (Admin) - Lagardère Paris Racing
  {
    id: '7001234579',
    userUid: '6789123450', // Amélie Mauresmo
    invoiceNumber: 'INV-PARIS-2024-001',
    dateGenerated: issueDate2,
    dueDate: dueDate2,
    status: 'Paid' as InvoiceStatus,
    planName: 'Paris Racing Premium Membership',
    amount: 180.00,
    currencyCode: 'CHF',
    clubId: '1928374650', // Paris Racing
    billingAccountId: 'acct_paris_racing_ch',
    pdfUrl: '/invoices/INV-PARIS-2024-001.pdf',
    organizationId: '9516274830',
    tenantId: '9516274830',
  },
  {
    id: '7001234580',
    userUid: '6789123450', // Amélie Mauresmo
    invoiceNumber: 'INV-PARIS-2024-002',
    dateGenerated: issueDate1,
    dueDate: dueDate1,
    status: 'Pending' as InvoiceStatus,
    planName: 'Multi-Sport Complex Annual Package',
    amount: 350.00,
    currencyCode: 'CHF',
    clubId: '3748591620', // Multi-Sport Complex
    billingAccountId: 'acct_paris_racing_ch',
    pdfUrl: '/invoices/INV-PARIS-2024-002.pdf',
    organizationId: '9516274830',
    tenantId: '9516274830',
  },
];
